import type { TAvailablePreset, TAvailablePresetId } from 'stores/userDetailsStore/helperTypes'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { apiFetch } from 'utils/apiFetch'
import type { TNewPresetState } from '../Presets'

export const submitNewPreset = async ({ newPresetState }: { newPresetState: TNewPresetState }) => {
  const newPhoneyTemporaryHash = String(Math.random())

  const optimisticUpdate: Record<TAvailablePresetId, TAvailablePreset> = {
    [newPhoneyTemporaryHash]: {
      ...(newPresetState as Pick<
        TAvailablePreset,
        'name' | 'dayOffsetDateFrom' | 'dayOffsetDateTo' | 'selectedValueGroups' | 'valueGroupForMap'
      >),
      idHash: newPhoneyTemporaryHash,
      ignored: false,
    },
  }

  userDetailsStore.setState((s) => ({
    ...s,
    availableUserDefinedPresets: {
      ...s.availableUserDefinedPresets,
      ...optimisticUpdate,
    },
  }))

  const newPresetToSend = {
    name: newPresetState.name as string,
    dayOffsetDateFrom: newPresetState.dayOffsetDateFrom as number,
    dayOffsetDateTo: newPresetState.dayOffsetDateTo as number,
    selectedValueGroups: newPresetState.selectedValueGroups as string[],
    valueGroupForMap: newPresetState.valueGroupForMap as string,
  }

  return apiFetch({
    url: '/app-presets-management',
    body: { newUserDefinedPresets: [newPresetToSend] },
  })
    .then((res) => {
      userDetailsStore.setState((s) => ({
        ...s,
        availableUserDefinedPresets: {
          ...s.availableUserDefinedPresets,
          ...optimisticUpdate,
        },
      }))

      const newPreset = res.newUserDefinedPresets?.[0] as TAvailablePreset

      if (!newPreset) return

      userDetailsStore.setState((s) => {
        const {
          [newPhoneyTemporaryHash]: optimisticUpdateToNotIncludeInNewList,
          ...nonOptimisticUpdateUserDefinedPresets
        } = s.availableUserDefinedPresets ?? {}

        return {
          ...s,
          availableUserDefinedPresets: {
            ...nonOptimisticUpdateUserDefinedPresets,
            [newPreset.idHash]: newPreset,
          },
        }
      })
    })
    .catch(() => {
      // TODO: errorLogger
    })
}
